import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core'
import { ClerkService } from '../services/clerk.service'
import { take } from 'rxjs'
import { UserProfileProps } from '@clerk/types'

@Component({
  selector: 'wm-front-clerk-user-profile',
  imports: [],
  template: `<div #ref></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ClerkUserProfileComponent implements AfterViewInit, OnDestroy {
  @ViewChild('ref') public ref: ElementRef | null = null

  @Input() public props: UserProfileProps | undefined

  private _clerk = inject(ClerkService)

  public ngAfterViewInit() {
    this._clerk.clerk$.pipe(take(1)).subscribe((clerk) => {
      clerk.mountUserProfile(this.ref?.nativeElement, this.props)
    })
  }

  public ngOnDestroy() {
    this._clerk.clerk$.pipe(take(1)).subscribe((clerk) => {
      clerk.unmountUserProfile(this.ref?.nativeElement)
    })
  }
}
